module.exports = __webpack_public_path__ + "b06d96db7caf773463fc95a13163bb2d.svg";